const changelog = [
  {
    version: "15.6.1",
    date: "23/09/2026",
    title: "Mapeamento das respostas HTTP",
    improvements: [
      "Corrigido o mapeamento das respostas dos nós HTTP para variáveis do FlowBuilder.",
      "Adicionada compatibilidade com configurações salvas nos formatos variable e variableName.",
      "As variáveis extraídas continuam isoladas pelo ticket durante a execução do fluxo."
    ]
  },
  {
    version: "15.6.0",
    date: "23/09/2026",
    title: "Variáveis disponíveis no atendimento",
    improvements: [
      "Variáveis no formato ${variavel} agora são processadas também nas mensagens digitadas no chat.",
      "Adicionadas variáveis de contato, ticket, fila, atendente, empresa, conexão, data, tags e carteira no envio manual.",
      "Campos personalizados podem ser usados no chat pelo formato ${campo_nome_do_campo}.",
      "Variáveis criadas durante o FlowBuilder são resolvidas com isolamento pelo ticket atual."
    ]
  },
  {
    version: "15.5.0",
    date: "22/09/2026",
    title: "Contatos e biblioteca de arquivos",
    improvements: [
      "Importação de contatos do aparelho com seleção da conexão, validação e resumo do processamento.",
      "Compatibilidade com os formatos de contatos em lista e indexados persistidos pelo Baileys.",
      "Importação Excel com reconhecimento automático das colunas e seleção inicial das linhas.",
      "Biblioteca de arquivos da empresa disponível diretamente no chat por acesso autenticado.",
      "Removido o item manual Figurinha WebP, mantendo a Biblioteca de figurinhas."
    ]
  },
  {
    version: "15.4.0",
    date: "22/09/2026",
    title: "Variáveis ampliadas do FlowBuilder",
    improvements: [
      "Adicionadas variáveis seguras de contato, ticket, fila, atendente, empresa, conexão, data e hora.",
      "Adicionado suporte aos campos personalizados do contato no formato ${campo_nome_do_campo}.",
      "Removido o item Abrir Chamado da barra lateral, sem excluir o componente ou alterar rotas do sistema.",
      "Mantida a interpolação em mensagens, blocos e menus nos fluxos com ou sem webhook."
    ]
  },
  {
    version: "15.3.1",
    date: "22/09/2026",
    title: "Variáveis do FlowBuilder",
    improvements: [
      "Corrigida a interpolação de variáveis em mensagens, blocos de conteúdo e menus do FlowBuilder.",
      "Variáveis no formato ${variavel} agora são processadas também em fluxos sem payload de webhook.",
      "Adicionado suporte consistente a ${nome}, ${numero}, ${telefone} e ${email}."
    ]
  },
  {
    version: "15.3.0",
    date: "04/09/2026",
    title: "Operação, segurança e atendimento",
    improvements: [
      "Histórico persistente de backups com validação de integridade SHA-256.",
      "Painel administrativo de saúde, armazenamento, banco de dados e Redis.",
      "Biblioteca de figurinhas isolada por empresa, com arrastar, converter, enviar e excluir por permissão.",
      "Exportação de conversas em PDF refeita para carregar o histórico completo sem travar a tela.",
      "Backup restaurável do PostgreSQL e das mídias atuais do sistema.",
      "Proteções adicionais de acesso, tamanho e caminho de arquivos administrativos."
    ]
  }
];

export default changelog;
